<template>
    <v-app-bar v-if="tabs.length > 0" color="white" class="subpages" height="50" flat>
        <div class="links d-flex align-center">
            <div class="tabs">
                <span v-for="(tab, index) in tabs" :key="index">
                    <router-link :to="`${tab.route}`" :data-cy="tab.id">
                        {{ $t(tab.title) }}
                    </router-link>
                </span>
            </div>
        </div>
    </v-app-bar>
</template>

<script>
export default {
    props: ['tabs']
};
</script>

<style lang="scss">
@import '@/scss/_colors.scss';

.subpages .v-toolbar__content {
    justify-content: center;
}
.links {
    .tabs {
        a {
            text-decoration: none;
            color: #575756;
            font-weight: 700;
            font-size: 0.8em;
            padding: 7.5px 16px;
            border-radius: 5px;
            sup {
                color: $primary;
            }
            &.router-link-exact-active {
                background-color: $primary !important;
                color: #fff !important;
                sup {
                    color: #fff;
                }
            }
        }
    }
}
</style>
